module.exports = __webpack_public_path__ + "img/paul_s.dd02c227.png";